














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Profil extends Vue {
    // @Prop() private title!: string;
}
